import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import useTheme from '@mui/styles/useTheme';

function OrderDetailItemCard({ name, value }) {
	const theme = useTheme();
	const { t } = useTranslation('order_details');

	return (
		<Grid item xs={12} role="paragraph" aria-label={t('order_details')} pr={2}>
			<Grid
				container
				item
				xs={12}
				style={{ paddingTop: '1rem', paddingBottom: '0' }}
				role="paragraph"
				aria-label={t('order_details')}
			>
				<Grid item xs={6} sm={4} md={5} role="paragraph" aria-label={name}>
					<Typography variant="heading8" role="paragraph" aria-label={name}>
						{t(`${name}`)}
					</Typography>
				</Grid>
				<Grid item xs={6} sm={6} md={7} role="paragraph" aria-label={name}>
					{typeof value === 'string' ? (
						<Typography
							variant="body"
							style={{ textTransform: theme.palette.textTransform.capitalize }}
							role="paragraph"
							aria-label={value}
						>
							{value.toString()}
						</Typography>
					) : (
						value
					)}
				</Grid>
			</Grid>
		</Grid>
	);
}

OrderDetailItemCard.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.any,
};

export default OrderDetailItemCard;
